import { drawerWidth, useGlobals } from 'src/shared/contexts/appContext';
import { DrawerHeader, closedMixin, openedMixin } from 'src/shared/components/navigations/side-menu/sideMenu.styles';
import { useTheme } from '@mui/material/styles';
import { Button, Drawer, IconButton } from '@mui/material';
import { Colors } from 'src/shared/components/styles/colors';
import { MenuOpenOutlined, MenuOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useTranslation } from 'react-i18next';
import LogoImage from 'src/shared/components/atoms/logoImage';

export const SideMenuDrawer = ({ children }) => {
  const { sideMenuOpen, setSideMenuOpen, systemMessage } = useGlobals();
  const theme = useTheme();

  const { t } = useTranslation(['common']);

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(RoutesEnum.Dashboard);
  };

  return (
    <Drawer
      variant='permanent'
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        zIndex: theme.zIndex.appBar - 1,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(sideMenuOpen && {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!sideMenuOpen && {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        }),
        '& .MuiTypography-root': {
          fontSize: '0.9rem',
          fontWeight: 500,
        },
        '& .MuiSvgIcon-root': {
          color: Colors.White,
        },
        boxShadow: 0,
      }}
    >
      <DrawerHeader sx={{ justifyContent: sideMenuOpen ? 'space-between' : 'center', mt: systemMessage ? `${systemMessage.height}px` : 0 }}>
        <Button
          role='banner'
          onClick={handleLogoClick}
          disableElevation
          sx={{
            m: 0,
            p: 0,
            borderRadius: 0,
            minWidth: 'auto',
          }}
          aria-label={t('common:headerToolbar.logoDescription')}
        >
          {sideMenuOpen && <LogoImage isSmall={!sideMenuOpen} />}
        </Button>
        <IconButton
          onClick={() => setSideMenuOpen(!sideMenuOpen)}
          aria-label={t('common:headerToolbar.showMenu')}
          aria-controls='sidemenu'
          aria-expanded={sideMenuOpen}
          sx={{ '& .MuiSvgIcon-root': { color: `${Colors.MenuIcon} !important` } }}
          size='large'
        >
          {sideMenuOpen ? <MenuOpenOutlined aria-hidden /> : <MenuOutlined aria-hidden />}
        </IconButton>
      </DrawerHeader>
      {children}
    </Drawer>
  );
};
